import { Dayjs } from 'dayjs'

import { dayOfWeek } from '~/astra'

export const commentStyles = 'bg-emerald-300/10  small-triangle-bookmark'
export const blockedDataGridStyles = 'opacity-50 transition-opacity [&>*]:pointer-events-none'
export const closedCellStyles = 'bg-dashed-surface-strong hover:bg-dashed-surface-strong'

export function getFridayStyles(date: Dayjs) {
    const fridayStyles = 'border-r-2 border-r-strong '
    return dayOfWeek(date) === 5 ? fridayStyles : ''
}
